// Copyright (c) 2021-22, iPivot, Corp.
'use strict'

const { darken, lighten } = require('polished')

const primaryColor = '#007aff'
const secondaryColor = '#f2f2f2'
const dangerColor = '#DD2C00'
const successColor = '#57c15c'
const warningColor = '#FAB519'
const infoColor = '#36B6DB'
const linkColor = '#1E6DD4'
const lightFontColor = 'rgba(255, 255, 255, 0.85)'
const darkFontColor = '#000000e6'

module.exports = {
    variant: 'light',
    productName: '',
    colors: {
        a: {
            color: linkColor,
            hover: {
                color: lighten(0.2, linkColor),
            },
        },
        accordion: {
            background: 'transparent',
            border: '1px solid #00000030',
            color: darkFontColor,
            iconColor: 'black',
            header: {
                color: darkFontColor,
                open: {
                    background: 'lightgrey',
                    color: darkFontColor,
                },
            },
        },
        alert: {
            danger: {
                background: `${dangerColor}40`,
                border: `1px solid ${dangerColor}`,
                color: darkFontColor,
            },
            primary: {
                background: `${primaryColor}40`,
                border: `1px solid ${primaryColor}`,
                color: darkFontColor,
            },
            secondary: {
                background: `${secondaryColor}40`,
                border: `1px solid ${secondaryColor}`,
                color: darkFontColor,
            },
            success: {
                background: `${successColor}40`,
                border: `1px solid ${successColor}`,
                color: darkFontColor,
            },
            warning: {
                background: `${warningColor}40`,
                border: `1px solid ${warningColor}`,
                color: darkFontColor,
            },
            info: {
                background: `${infoColor}20`,
                border: `1px solid ${infoColor}`,
                color: darkFontColor,
            },
        },
        badge: {
            danger: {
                background: '#DD2C00',
                color: '#FFFFFF',
            },
            primary: {
                background: '#0055B7',
                color: '#FFFFFF',
            },
            secondary: {
                background: '#DADADA',
                color: '#000000',
            },
            success: {
                background: '#0ED600',
                color: '#333333',
            },
            warning: {
                background: '#FFC000',
                color: '#393939',
            },
            info: {
                background: '#007C84',
                color: '#FFFFFF',
            },
        },
        body: {
            background: '#FAFAFA',
            color: darkFontColor,
            dangerColor,
            successColor,
        },
        dropdown: {
            button: {
                secondary: {
                    active: {
                        background: 'transparent',
                        color: linkColor,
                    },
                },
            },
        },
        button: {
            primary: {
                background: primaryColor,
                border: `1px solid ${primaryColor}`,
                color: lightFontColor,
                boxShadow: 'rgba(27, 31, 35, 0.04) 0 1px 0, rgba(255, 255, 255, 0.25) 0 1px 0 inset',
                active: {
                    background: `${primaryColor}DD`,
                    border: `1px solid ${primaryColor}`,
                    color: lightFontColor,
                },
                disabled: {
                    background: `${primaryColor}80`,
                    border: `1px solid ${primaryColor}`,
                    color: lightFontColor,
                },
                hover: {
                    background: `${primaryColor}DD`,
                    border: `1px solid ${primaryColor}`,
                    color: lightFontColor,
                    boxShadow: 'rgba(27, 31, 35, 0.04) 0 1px 0, rgba(255, 255, 255, 0.25) 0 1px 0 inset',
                },
            },
            secondary: {
                background: secondaryColor,
                border: `1px solid ${darken(0.1, secondaryColor)}`,
                color: darkFontColor,
                boxShadow: `none`,
                active: {
                    background: '#b2b2b2',
                    border: `1px solid ${darken(0.1, secondaryColor)}`,
                    color: lightFontColor,
                    boxShadow: `none`,
                },
                disabled: {
                    background: secondaryColor,
                    border: `1px solid ${secondaryColor}`,
                    color: darkFontColor,
                },
                hover: {
                    background: lighten(0.025, secondaryColor),
                    border: `1px solid ${lighten(0.025, secondaryColor)}`,
                    color: darkFontColor,
                    boxShadow: `0px 0px 0px 2px #ececec`,
                },
            },
            light: {
                color: darkFontColor,
            },
            success: {
                background: successColor,
                border: `1px solid ${successColor}`,
                color: lightFontColor,
                boxShadow: `none`,
                active: {
                    background: successColor,
                    border: `1px solid ${successColor}`,
                    color: lightFontColor,
                },
                disabled: {
                    background: successColor,
                    border: `1px solid ${successColor}`,
                    color: lightFontColor,
                },
                hover: {
                    background: lighten(0.025, successColor),
                    border: `1px solid ${lighten(0.025, successColor)}`,
                    color: lightFontColor,
                    boxShadow: `0px 0px 0px 2px #ececec`,
                },
            },
            danger: {
                background: dangerColor,
                border: `1px solid ${dangerColor}`,
                color: lightFontColor,
                boxShadow: `none`,
                active: {
                    background: dangerColor,
                    border: `1px solid ${dangerColor}`,
                    color: lightFontColor,
                },
                disabled: {
                    background: dangerColor,
                    border: `1px solid ${dangerColor}`,
                    color: lightFontColor,
                },
                hover: {
                    background: lighten(0.025, dangerColor),
                    border: `1px solid ${lighten(0.025, dangerColor)}`,
                    color: lightFontColor,
                    boxShadow: `0px 0px 0px 2px #d3373787`,
                },
            },
        },
        buttonGroup: {
            primary: {
                background: 'transparent',
                border: `1px solid ${primaryColor}`,
                color: primaryColor,
                boxShadow: `none`,
                active: {
                    background: primaryColor,
                    border: `1px solid ${primaryColor}`,
                    color: lightFontColor,
                },
                disabled: {
                    background: primaryColor,
                    border: darken(0.1, primaryColor),
                    color: lightFontColor,
                },
                hover: {
                    background: 'transparent',
                    border: `1px solid ${primaryColor}`,
                    color: primaryColor,
                    boxShadow: `0px 0px 0px 2px #E0F7FA`,
                },
            },
            secondary: {
                background: 'transparent',
                border: `1px solid ${secondaryColor}`,
                color: secondaryColor,
                boxShadow: `none`,
                active: {
                    background: secondaryColor,
                    border: `1px solid ${secondaryColor}`,
                    color: lightFontColor,
                },
                disabled: {
                    background: secondaryColor,
                    border: darken(0.1, secondaryColor),
                    color: lightFontColor,
                },
                hover: {
                    background: 'transparent',
                    border: `1px solid ${secondaryColor}`,
                    color: secondaryColor,
                    boxShadow: `0px 0px 0px 2px #E0F7FA`,
                },
            },
        },
        card: {
            background: '#FFFFFF',
            border: '1px solid #d3d3d3',
            boxShadow: '0px 0px 0px 1px #EEEEEE',
            borderRadius: '5px',
            color: darkFontColor,
            footer: {
                background: '#FFFFFF',
                border: '1px 0px 0px 0px solid gray',
                color: darkFontColor,
            },
            header: {
                background: '#FFFFFF',
                border: '1px 0px 0px 0px solid gray',
                color: darkFontColor,
            },
            hover: {
                boxShadow: `0 0 0 0.2rem ${linkColor}`,
            },
        },
        charts: {
            backgroundColor: '#FFF',
            borderColor: '#d3d3d3',
            textColor: darkFontColor,
            axisColor: darkFontColor,
            tooltip: {
                backgroundColor: '#FCFCFC',
                border: '2px solid #EFEFEF',
                textColor: darkFontColor,
            },
            gray: { backgroundColor: '#C4C4C4', textColor: darkFontColor },
            blue: { backgroundColor: '#36B6DB', textColor: '#373737' },
            green: { backgroundColor: '#7EDB64', textColor: '#4C4C4C' },
            orange: { backgroundColor: '#DB9F23', textColor: '#383838' },
            purple: { backgroundColor: '#7E36DC', textColor: '#FFFFFF' },
            lightPurple: { backgroundColor: '#C8B3E6', textColor: '#454545' },
            red: { backgroundColor: '#DB2B18', textColor: '#FFFFFF' },
        },
        dropdownMenu: {
            background: '#FFFFFF',
            color: darkFontColor,
            active: {
                background: '#FFFFFF',
                color: '#000000',
                fontWeight: '600',
            },
            hover: {
                background: '#FFFFFF',
                color: '#000000',
                fontWeight: '400',
            },
        },
        evidence: {
            backgroundColor: '#FEFEFE',
            border: '1px solid #E0E0E0',
            boxShadowColor: darkFontColor,
            color: darkFontColor,
        },
        formCheck: {
            background: primaryColor,
            border: primaryColor,
            color: lightFontColor,
            focus: {
                boxShadow: `0 0 0 2px rgba(0, 176, 198, 0.2)`,
            },
        },
        formControl: {
            backgroundColor: '#ffffff',
            border: '1px solid #00000030',
            boxShadow: '0 0 0 0.15rem #00a6ff80',
            color: darkFontColor,
            error: dangerColor,
            success: successColor,
            disabled: {
                backgroundColor: '#e9ecef',
            },
            focus: {
                background: '#FFFFFF',
                border: '1px solid #2684FF',
                boxShadow: `0 0 0 1px #2684FF`,
                color: darkFontColor,
            },
            isValid: {
                boxShadow: '0 0 0 0.15rem #3dc64380',
            },
            isInvalid: {
                boxShadow: `0 0 0 0.15rem #E5393580`,
            },
        },
        inputGroup: {
            background: secondaryColor,
            border: '1px solid #00000030',
            color: darkFontColor,
        },
        reactSelect: {
            backgroundColor: '#ffffff',
            color: darkFontColor,
            borderColor: '#00000030',
            invalid: {
                boxShadow: '0 0 0 0.15rem #E5393580',
            },
            multi: {
                backgroundColor: '#d8d8d8',
                color: darkFontColor,
            },
            focus: {
                backgroundColor: 'lightgrey',
                color: darkFontColor,
            },
            active: {
                backgroundColor: 'lightgrey',
                color: darkFontColor,
            },
            selected: {
                backgroundColor: linkColor,
                color: lightFontColor,
            },
            valid: {
                boxShadow: '0 0 0 0.15rem #3dc64380',
            },
        },
        listGroupItem: {
            background: 'transparent',
            borderColor: '#00000030',
            color: darkFontColor,
        },
        modal: {
            background: '#ffffff',
            border: '1px solid #00000030',
            boxShadow: 'none',
            borderRadius: '5px',
            color: darkFontColor,
        },
        motd: {
            backgroundColor: warningColor,
            color: darkFontColor,
            boxShadowColor: '#a9a9a9',
        },
        nav: {
            background: darkFontColor,
            borderBottom: 'solid 1px #212121',
            color: lightFontColor,
            hover: {
                color: '#FFFFFF',
            },
            active: {
                background: 'transparent',
                borderBottom: `3px solid ${dangerColor}`,
                fontWeight: '600',
                color: darkFontColor,
            },
            disabled: {
                color: '#9E9E9E',
            },
            dropdownMenu: {
                background: '#FFFFFF',
                color: darkFontColor,
                active: {
                    background: '#FFFFFF',
                    color: '#000000',
                    fontWeight: '600',
                },
                hover: {
                    background: '#FFFFFF',
                    color: '#000000',
                    fontWeight: '400',
                },
            },
        },
        navPills: {
            background: 'transparent',
            border: `3px solid ${primaryColor}`,
            color: primaryColor,
        },
        pdf: {
            textColor: '#000',
        },
        popover: {
            background: '#ffffff',
            border: '1px solid #00000030',
            color: darkFontColor,
            header: {
                borderBottom: '1px solid #00000030',
            },
        },
        pre: {
            backgroundColor: '#F5F5F5',
        },
        progressBar: {
            backgroundColor: secondaryColor,
            color: darkFontColor,
        },
        sideMenu: {
            background: '#FFFFFF',
            borderLeft: '1px solid lightgrey',
            boxShadow: '0px 0px 0px 1px #EEEEEE',
            borderRadius: '0px',
            color: darkFontColor,
        },
        systemInfo: {
            background: '#212121',
            color: lightFontColor,
            button: {
                primary: {
                    background: primaryColor,
                    border: `1px solid ${primaryColor}`,
                },
                secondary: {
                    background: secondaryColor,
                    border: `1px solid ${secondaryColor}`,
                },
            },
        },
        table: {
            background: 'inherit',
            borderColor: 'darkgrey',
            color: darkFontColor,
            input: {
                backgroundColor: 'white',
                borderColor: 'grey',
                boxShadowColor: darkFontColor,
                color: darkFontColor,
            },
            active: {
                backgroundColor: 'blue',
                borderColor: 'blue',
                color: lightFontColor,
            },
            hover: {
                color: darkFontColor,
                backgroundColor: '#f1f1f1',
            },
            highlight: {
                background: primaryColor,
                border: `1px solid rgba(255, 255, 255, 0.9)`,
                color: lightFontColor,
            },
        },
        tabs: {
            background: '#FFFFFF',
            borderBottom: '1px solid lightgrey',
            borderLeft: '1px solid lightgrey',
            borderRadius: '0px 0px 5px 5px',
            borderRight: '1px solid lightgrey',
            boxShadow: '0px 0px 0px 1px #EEEEEE',
            color: darkFontColor,
            active: {
                boxShadow: '-1px 0px 0px 0px #EEEEEE',
            },
        },
        text: {
            primary: {
                color: '#1E6DD4',
            },
            secondary: {
                color: '#494949',
            },
            success: {
                color: '#367E3A',
            },
            danger: {
                color: '#DD2C00',
            },
            warning: {
                color: '#92680A',
            },
            info: {
                color: '#007C84',
            },
            muted: {
                color: '#595959',
            },
        },
    },
    fonts: ['sans-serif', 'Roboto'],
    fontSizes: {
        small: '1em',
        medium: '2em',
        large: '3em',
    },
    images: {
        complianceCertificates: {
            logo: 'dragonfly-logo-black.png',
            companyName: 'Dragonfly Cyber',
            signatureImage: 'brett_signature.png',
            signatoryName: 'Brett Helm',
            signatoryTitle: 'CISO',
            awardedIcon: 'compliance-certificate-awarded-icon.png',
            notAwardedIcon: 'compliance-certificate-not-awarded-icon.png',
        },
        favicon: 'dragonfly-favicon.png',
        loginLogo: 'dragonfly-logo-black.png',
        logo: 'dragonfly-logo.png',
        logoImgAlt: 'Dragonfly Cyber',
        pdfCoverLogo: 'dragonfly-logo-black.png',
        secondaryLogo: 'dragonfly-logo-black.png',
    },
}
